import { getLocale } from "../runtime";

const sv_xproducts = /** @type {(inputs: {value: NonNullable<unknown>}) => string} */ (inputs) => {
	return `${inputs.value} produkter`
};

const xproducts = /** @type {(inputs: {value: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_xproducts(inputs)
	return "xProducts";
};

export { xproducts as "xProducts" };